export default function ({ route, $track, env }) {
  // console.log(' ga4ViewTracking js ', (typeof $track))
  if (typeof $track === 'function') {
    // $track({ type: 'page_view_custom', event: { 'ep.abc': 'def' }, debug: true })
    $track({ event: { 'ep.platform': 'web' }, debug: env.ga4Debug })
    // console.log(' track --')
  }
}
